import React from 'react';
import {
  Music,
  Trophy,
  Palette,
  Briefcase,
  HeartHandshake,
  GraduationCap,
  Clapperboard,
  Users,
  Shirt,
  UtensilsCrossed,
  Church,
  Sparkles,
  Moon,
  Laptop,
  Mountain,
  Ticket,
  Landmark,
  Plane,
  Baby,
  HandHeart
} from 'lucide-react';

const LUCIDE_ICONS = {
  Music,
  Sports: Trophy,
  Arts: Palette,
  'Arts & Culture': Palette,
  Culture: Landmark,
  Business: Briefcase,
  'Business & Networking': Briefcase,
  Technology: Laptop,
  'Food & Drink': UtensilsCrossed,
  Education: GraduationCap,
  'Education & Training': GraduationCap,
  Family: Users,
  'Family & Kids': Baby,
  Entertainment: Clapperboard,
  'Health & Wellness': Sparkles,
  Nightlife: Moon,
  'Gospel & Faith': Church,
  Fashion: Shirt,
  'Fashion & Beauty': Shirt,
  Travel: Plane,
  'Travel & Outdoor': Mountain,
  Community: HeartHandshake,
  'Community & Charity': HandHeart
};

/** Warm, on-brand accent per category */
export const CATEGORY_ACCENT = {
  Music: '#EA580C',
  Sports: '#D97706',
  'Arts & Culture': '#C026D3',
  Arts: '#C026D3',
  Culture: '#9333EA',
  Business: '#2563EB',
  Technology: '#0891B2',
  'Food & Drink': '#E11D48',
  Education: '#4F46E5',
  Family: '#DB2777',
  Entertainment: '#DC2626',
  Nightlife: '#7C3AED',
  'Gospel & Faith': '#6366F1',
  Fashion: '#BE185D',
  'Health & Wellness': '#059669',
  'Travel & Outdoor': '#0D9488',
  Community: '#CA8A04'
};

export function getCategoryLucideIcon(name) {
  return LUCIDE_ICONS[name] || Ticket;
}

export function getCategoryAccent(name) {
  return CATEGORY_ACCENT[name] || '#EA580C';
}

export function CategoryLucideIcon({
  name,
  size = 38,
  strokeWidth = 1.5,
  className = '',
  style
}) {
  const Icon = getCategoryLucideIcon(name);
  return (
    <Icon
      size={size}
      strokeWidth={strokeWidth}
      className={className}
      style={style}
      aria-hidden
    />
  );
}

export default CategoryLucideIcon;
